var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-collapse",
    { staticClass: "d2-search-panel", attrs: { value: _vm.active } },
    [
      _c("el-collapse-item", { attrs: { name: _vm.name } }, [
        _c(
          "div",
          {
            staticClass: "d2-search-panel--title",
            attrs: { slot: "title", flex: "" },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.onItemClick.apply(null, arguments)
              }
            },
            slot: "title"
          },
          [
            _vm.hasPrefixSlot ? _c("div", [_vm._t("prefix")], 2) : _vm._e(),
            _vm.hasContentSlot
              ? _c("d2-button", {
                  class: {
                    "d2-ml-10": _vm.hasPrefixSlot,
                    "d2-mr-10": _vm.hasTitleSlot
                  },
                  attrs: {
                    icon: _vm.buttonIcon,
                    label: _vm.buttonLabel,
                    "flex-box": "0",
                    plain: "",
                    thin: ""
                  },
                  on: { click: _vm.toggle }
                })
              : _vm._e(),
            _vm.hasTitleSlot
              ? _c("div", { attrs: { "flex-box": "1" } }, [_vm._t("title")], 2)
              : _vm._e()
          ],
          1
        ),
        _vm.hasContentSlot
          ? _c(
              "div",
              { staticClass: "d2-search-panel--content" },
              [_vm._t("default")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }